<span class="content">
  <ng-content></ng-content>
</span>
@if (icon(); as icon) {
  <span class="icon" [ngClass]="icon"></span>
}
